import React from "react";

export const Pill = ({ label, value }) => (
  <div className="flex flex-col items-center gap-1 text-center">
    <span className="text-[10px] uppercase tracking-wide text-slate-300 text-center w-full">
      {label}
    </span>
    <div
      className="flex items-center justify-center px-4 h-8 w-full max-w-[160px] rounded-full border border-slate-300/70 text-[11px] text-white bg-white/5"
      title={value}
    >
      <span className="truncate">{value}</span>
    </div>
  </div>
);
